import { Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import HoursInput from "../../../../components/ui/HoursInput";
import WeekInput from "../../../../components/ui/WeekInput";
import DaysInput from "../../../../components/ui/DaysInput";
import MonthInput from "../../../../components/ui/MonthInput";
import SrvButton from "../../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../../util/ErrorAdd";

function CardTimetableEdit({ model, idTask, show, onHide }) {

    const [loading, setLoading] = useState(null);
    const [log, setLog] = useState(null);


    const [minute, setMinute] = useState(0);
    const [hour, setHour] = useState(0);
    const [day, setDay] = useState(null);
    const [dayWeek, setDayWeek] = useState(null);
    const [month, setMonth] = useState(null);
    const [dayComplete, setDayComplete] = useState(null);
    const [comment, setComment] = useState(null);


    const [idType, setIdType] = useState(null);
    const [typeParam, setTypeParam] = useState(
        [
            { id: 1, name: 'Ежедневно', selected: false },
            { id: 2, name: 'Еженедельно', selected: false },
            { id: 3, name: 'Ежемесячно', selected: false },
            { id: 4, name: 'Ежегодно', selected: false },
            { id: 5, name: 'Ручное', selected: false },
        ]
    );

    useEffect(() => {
        if (model !== null) {
            setIdType(model.ID_Type);
            setHour(model.Hour);
            setMinute(model.Minute)
            setDay(model.Day);
            setDayWeek(model.Week_Day);
            setMonth(model.Month);
            setDayComplete(model.Day_Complite);
            setComment(model.Comment);
        }

    }, [model]);


    function updateHandler() {

        setLoading(true);
        setLog(null);

        if (idType === null) {
            setLog('Выберите тип расписания');
            setLoading(false);
        }
        else if (hour === null || minute === null || hour === -1 || minute === -1) {
            setLog('Выберите время');
            setLoading(false);
        }
        else if (idType === 2 & dayWeek === null) {
            setLog('Выберите день недели');
            setLoading(false);
        }
        else if (idType === 3 & day === null) {
            setLog('Выберите число');
            setLoading(false);
        }
        else if (idType === 4 & month === null) {
            setLog('Выберите месяц');
            setLoading(false);
        }
        else if (idType === 4 & day === null) {
            setLog('Выберите число');
            setLoading(false);
        }
        else {
            if (model === null) {
                axios.post('/api_tracker/taskR/timetableAdd', { ID_TaskR: idTask, ID_Type: idType, Month: month, Week_Day: dayWeek, Day: day, Day_Complete: dayComplete, Hour: hour, Hour_Complete: null, Minute: minute, Comment: comment })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            onHide();
                            setLoading(false);
                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
            else {
                axios.post('/api_tracker/taskR/timetableUpdate', { ID_Timetable: model.ID, ID_TaskR: idTask, Month: month, Week_Day: dayWeek, Day: day, Day_Complete: dayComplete, Hour: hour, Hour_Complete: null, Minute: minute, Comment: comment, Archive: false })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            onHide();
                            setLoading(false);
                        }
                        else {
                            setLog(res.data.Error);
                            setLoading(false);
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
    }

    return (
        <>
            {show === true && (
                <Modal show={show} onHide={() => onHide()} >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center">{model === null ? ("Добавление расписания") : ("Редактирование расписания")}</div>

                        <div className="mt-15 row">
                            {typeParam.map(item => (
                                <div key={item.id} className="col-md-4 mt-10">
                                    <button className={'param_button' + (item.id === idType ? ' active' : '')} onClick={() => setIdType(item.id)}>
                                        {item.name}
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="mt-25">
                            {idType === 0 && (
                                <div className="row">
                                    <div className="col-md-12 text-center mb-15" style={{ fontSize: "20px" }}>
                                        Выберите тип расписания
                                    </div>
                                </div>
                            )}
                            {idType === 1 && (
                                <div className="row">
                                    <div className="col-md-4">
                                        <HoursInput label={"Время:"} changeValue={{ hour: hour, minute: minute }} change={(res) => { setHour(res.hour); setMinute(res.minute) }} />
                                    </div>
                                </div>
                            )}
                            {idType === 2 && (
                                <>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <WeekInput label={"День недели:"} defaultValue={dayWeek} change={(e) => setDayWeek(e.target.value)} />
                                        </div>
                                        <div className="col-md-4">
                                            <HoursInput label={"Время:"} changeValue={{ hour: hour, minute: minute }} change={(res) => { setHour(res.hour); setMinute(res.minute) }} />
                                        </div>
                                    </div>
                                    <div className="row mt-10">
                                        <div className="col-md-8">
                                            <Form.Group>
                                                <Form.Label>Кол-во дней для решения задачи*:</Form.Label>
                                                <Form.Control type="number" style={{ width: "70px" }} defaultValue={dayComplete} onChange={(e) => setDayComplete(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className="mt-15">* Кол-во дней для решения задачи - по истечению указанного кол-ва дней, если не завершить задачу, то она поменяет статус на «просрочена». Такие задачи будут выделены красным цветом. Ежедневно будут приходить уведомления о просроченной задаче.</div>
                                </>
                            )}
                            {idType === 3 && (
                                <>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <DaysInput label={"Число:"} defaultValue={day} change={(e) => setDay(e.target.value)} />
                                        </div>
                                        <div className="col-md-4">
                                            <HoursInput label={"Время:"} changeValue={{ hour: hour, minute: minute }} change={(res) => { setHour(res.hour); setMinute(res.minute) }} />
                                        </div>
                                    </div>
                                    <div className="row mt-10">
                                        <div className="col-md-8">
                                            <Form.Group>
                                                <Form.Label>Кол-во дней для решения задачи*:</Form.Label>
                                                <Form.Control type="number" style={{ width: "70px" }} defaultValue={dayComplete} onChange={(e) => setDayComplete(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className="mt-15">* Кол-во дней для решения задачи - по истечению указанного кол-ва дней, если не завершить задачу, то она поменяет статус на «просрочена». Такие задачи будут выделены красным цветом. Ежедневно будут приходить уведомления о просроченной задаче.</div>
                                </>
                            )}
                            {idType === 4 && (
                                <>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <MonthInput label={"Месяц:"} defaultValue={month} change={(e) => setMonth(e.target.value)} />
                                        </div>
                                        <div className="col-md-4">
                                            <DaysInput label={"Число:"} defaultValue={day} change={(e) => setDay(e.target.value)} />
                                        </div>
                                        <div className="col-md-4">
                                            <HoursInput label={"Время:"} changeValue={{ hour: hour, minute: minute }} change={(res) => { setHour(res.hour); setMinute(res.minute) }} />
                                        </div>
                                    </div>
                                    <div className="row mt-10">
                                        <div className="col-md-8">
                                            <Form.Group>
                                                <Form.Label>Кол-во дней для решения задачи*:</Form.Label>
                                                <Form.Control type="number" style={{ width: "70px" }} defaultValue={dayComplete} onChange={(e) => setDayComplete(e.target.value)} />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className="mt-15">* Кол-во дней для решения задачи - по истечению указанного кол-ва дней, если не завершить задачу, то она поменяет статус на «просрочена». Такие задачи будут выделены красным цветом. Ежедневно будут приходить уведомления о просроченной задаче.</div>
                                </>
                            )}
                            {idType === 5 && (

                                <div className="row">
                                    <div className="col-md-12">
                                        Данный тип расписания предназначен для ручного выставления задач с помощью кнопки "Отправить пользователям"
                                    </div>
                                </div>

                            )}
                            {idType != 5 && (
                                <Form.Group className="mt-10">
                                    <Form.Label>Комментарий:</Form.Label>
                                    <Form.Control as="textarea" rows={3} defaultValue={comment} onChange={(e) => setComment(e.target.value)} />
                                </Form.Group>
                            )}
                        </div>

                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}

                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="save" size='lg' onClick={() => updateHandler()} loading={loading} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}

export default CardTimetableEdit;